import { render, staticRenderFns } from "./subscription-header.vue?vue&type=template&id=2a896098&scoped=true&"
import script from "./subscription-header.vue?vue&type=script&lang=js&"
export * from "./subscription-header.vue?vue&type=script&lang=js&"
import style0 from "./subscription-header.vue?vue&type=style&index=0&id=2a896098&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a896098",
  null
  
)

export default component.exports